<template>
  <div style="width: 100%;" v-loading.body="receivingStatus">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          Employee Earnings Report
        </el-row>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button plain @click="generateReport" :disabled="disableReportRun || !!renderingReport">
            Run report
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.3em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Employee
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="reportOptions.employeeQuickPick" :disabled="receivingStatus || disableReportRun">
          <el-radio-button label="custom">Custom</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row v-if="reportOptions.employeeQuickPick==='custom'" align="middle" justify="start" class="headerRow" style="padding-left: 9vw;">
      <el-col :span="24">
        <el-transfer
        ref="employeeTransfer"
        v-model="selectedCodes.employee_id"
        :data="employeeData"
        :titles="[ 'Unselected Employees', 'Selected Employees' ]"
        :props="{ key: 'propay_reference_id', label: 'display_name' }"
        filterable
        filter-placeholder="Search Employee"
        >
        </el-transfer>
      </el-col>
     </el-row>
     <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Invoice
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="reportOptions.invoiceQuickPick" :disabled="receivingStatus || disableReportRun">
          <el-radio-button label="custom">Custom</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row v-if="reportOptions.invoiceQuickPick==='custom'" align="middle" justify="start" class="headerRow" style="padding-left: 9vw;">
      <el-col :span="24">
        <el-transfer
        ref="invoiceTransfer"
        v-model="selectedCodes.invoice_id"
        :data="invoiceData"
        :titles="[ 'Unselected Invoices', 'Selected Invoices' ]"
        :props="{ key: 'invoice_number', label: 'display_name' }"
        filterable
        filter-placeholder="Search Invoice"
        >
        </el-transfer>
      </el-col>
     </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Output
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedCodes.format">
          <el-option
            v-for="opt in outputFormats"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Week end date
      </el-col>
      <el-col :span="4">
        <DateField
          name="f.name"
          :dataoptions="{ 'data-type': 'date' }"
          v-model="selectedCodes.date"
          />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { reportMixins } from '@/Mixins/Reports'
  import { mapGetters } from 'vuex'
  import { notify } from '@/utils/helpers/Notify'
  import DateField from '@/components/InputComponents/DateField.vue'
  export default {
    name: 'employeeEarningReport',
    mixins: [ reportMixins ],
    components: { DateField },
    data () {
      return {
        report_group: 'Employee_Earning_Report',
        loading: false,
        prettyJson: '',
        disableReportRun: false,
        outputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        allEmployees: [],
        reportOptions: { employeeQuickPick: 'all', invoiceQuickPick: 'all' },
        allInvoices: [],
        selectedCodes: undefined
      }
    },
    methods: {
      resetComponent () {
        this.resetFilters()
      },
      async generateReport () {
        this.disableReportRun = true

        const data = Object.assign({}, { employee: this.selectedCodes.employee_id && this.selectedCodes.employee_id.length ? this.selectedCodes.employee_id : this.allEmployees.map((employee) => employee.propay_reference_id), invoice_number: this.selectedCodes.invoice_id && this.selectedCodes.invoice_id.length ? this.selectedCodes.invoice_id : this.allInvoices.map((invoice) => invoice.invoice_number) },
        this.selectedCodes.format === 'csv' ? { format: this.selectedCodes.format } : {}, this.selectedCodes.date ? { week_end_date: this.selectedCodes.date } : {}
        )
        this.selectedCodes.format === 'csv' ? '' : delete data.format
        await this.$store.dispatch('cacheParams', { data })
        .then(async r => {
          if (!(r && r.id)) return Promise.reject('No response')
          const { reportId } = r
          let query = { cached_parameters: r.id }
          const payload = { query, type: this.selectedCodes.format === 'csv' ? 'propay/earningsinfo/' : 'propay/earnings', reportId }
          return this.selectedCodes.format === 'csv' ? this.downloadCSVfromAPI(payload, 'Employee Earnings Report') : await this.$store.dispatch('startRenderingReport', payload)
        })
        .catch(e => {
          console.log(e)
          notify(this, 'error', 'Error generating posting report')
        })

        this.disableReportRun = false
      },

      resetFilters () {
        this.selectedCodes = {
          employee_id: undefined,
          invoice_id: undefined,
          format: 'pdf'
        }
      },

      async getInvoices () {
        return new Promise((resolve, reject) => {
          const promises = [
            this.$store.dispatch('fetchAllInvoices')
          ]
          Promise.all(promises)
          .then(response => {
            this.allInvoices = this.$store.getters.getAllCodes.invoiceCodes
            resolve(true)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
        })
      },

      async getEmployeeCodes () {
        return new Promise((resolve, reject) => {
        // Don't get values if already in store as these don't typically change in between report runs
          if (typeof this.$store.getters.getAllCodes.employeecodes !== 'undefined' && this.$store.getters.getAllCodes.employeecodes.length > 0) {
            this.allEmployees = this.$store.getters.getAllCodes.employeecodes
            resolve(true)
          } else {
            const promises = [
              this.$store.dispatch('fetchAllEmployees')
            ]
            Promise.all(promises)
            .then(response => {
              this.allEmployees = this.$store.getters.getAllCodes.employeecodes
              resolve(true)
            })
            .catch(error => {
              console.log(error)
              reject(error)
            })
          }
        })
      }
    },

    computed: {
      ...mapGetters({
        renderingReport: 'getReportRenderStatus',
        receivingStatus: 'getReceivingStatus'
      }),
      employeeData () {
        return this.allEmployees
          .filter(employee => employee.last_name)
          .reduce((acc, current) => {
            if (!acc.some(emp => emp.propay_reference_id === current.propay_reference_id)) {
              acc.push({
                ...current,
                display_name: `${current.last_name}, ${current.first_name}`
              })
            }
            return acc
          }, [])
          .sort((a, b) => {
            const lastNameA = a.last_name || ''
            const lastNameB = b.last_name || ''
            return lastNameA.localeCompare(lastNameB)
          })
      },
      invoiceData () {
        return this.allInvoices.filter(i => i.invoice_number).reduce((acc, current) => {
          if (!acc.some(item => item.invoice_number === current.invoice_number)) {
            acc.push({
              ...current,
              display_name: `${current.invoice_number}`
            })
          }
          return acc
        }, [])
        .sort((a, b) => a.invoice_number.localeCompare(b.invoice_number))
      }
    },

    watch: {
      'reportOptions.employeeQuickPick' () {
        this.selectedCodes.employee_id = []
      },
      'reportOptions.invoiceQuickPick' () {
        this.selectedCodes.invoice_id = []
      }
    },

    beforeCreate () {
    },

    async created () {
        // Load data to be used for validation
      this.loading = true
      this.disableReportRun = true
      await this.resetFilters()
      await this.getEmployeeCodes()
      await this.getInvoices()
      this.disableReportRun = false
      this.loading = false
    },

    mounted () {
    },

    beforeDestroy () {
      this.resetComponent()
    }
  }

</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
</style>



// WEBPACK FOOTER //
// src/components/Reports/EmployeeEarningsReport.vue